import { getHeaders, makeRequest } from "$utils/utils";
import config from "./config";

const url = config.api_url;

export const deleteMedia = async (token: string, mediaId: string) => {
  try {
    const res = await makeRequest(
      `${url}/api/media/delete/${mediaId}`,
      "DELETE",
      {},
      getHeaders(token)
    );
    return res;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log(e);
    return e;
  }
};

export const getMedia = async (token: string, mediaId: string) => {
  try {
    const res = await makeRequest(
      `${url}/api/media/${mediaId}`,
      "GET",
      {},
      getHeaders(token)
    );
    return res.data.data;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log(e);
    throw e;
  }
};
